import { useEffect, useState } from "react";
import { ContactInfoWrapper } from "./style";
import { useDispatch } from "react-redux";

import Text from "components/common/Text";
import Input from "components/common/Input";
import Button from "components/common/Button";
import Image from "next/image";
import { InputAdornment } from "@mui/material";
import ConfirmationCode from "./ConfirmationCode";
import SecurityAlert from "./SecurityAlert";
import CountDown from "components/common/CountDown";

import Translation from "libs/Translation";
import Util from "libs/Util";
import ToastManager from "libs/ToastManager";
import ModalManager from "libs/ModalManager";

import { postAPI } from "redux/core/actions";

const SignUp = ({ webConfig, setStep }) => {
  const dispatch = useDispatch();
  const [securityWarn, setSecurityWarn] = useState();
  const [value, setValue] = useState({});
  const [loading, setLoading] = useState();
  const [countryCode, setcountryCode] = useState("98");
  const [phoneNumber, setPhoneNumber] = useState();
  const optLimitTime = Util.setFutureTimer(120);

  useEffect(() => {
    setValue({
      phoneNumber: Util.fixPhone(Util.convertToEngNum(phoneNumber)),
      countryCode: countryCode,
    });
  }, [phoneNumber]);

  const handleChange = (e) => {
    const { value } = e.target;
    setPhoneNumber(value);
  };

  const handleConfirm = () => {
    setLoading(true);
    setSecurityWarn(false);

    dispatch(postAPI("signUp", value, null, "nestApi"))
      .then((response) => {
        if (response?.isSuccess === true) {
          setStep({
            name: "confirmationCode",
            component: (
              <ConfirmationCode
                webConfig={webConfig}
                phoneNumber={value}
                setStep={setStep}
              />
            ),
          });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err.message === "Do not allowd") {
          ModalManager.show({
            content: <SecurityAlert />,
            title: "",
            maxWidth: "lg",
            hideCloseButton: true,
          });
          setSecurityWarn(true);
        } else {
          ToastManager.show(Translation.t("text.error-occurred"), webConfig);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkValidity = (e) => {
    e.preventDefault();
    const valid = Util.validatePhone(value.phoneNumber);
    valid
      ? handleConfirm()
      : ToastManager.show(
          Translation.t("text.the-phone-is-invalid"),
          webConfig
        );
  };

  return (
    <ContactInfoWrapper onSubmit={checkValidity}>
      <Image
        src="/nextasset/images/Logo.svg"
        width={155}
        height={59}
        alt="vclinic-logo"
      />
      <Text className="title" tag="span">
        {Translation.t("title.signup")}
      </Text>
      <Text className="desc" tag="span">
        {Translation.t("label.enter-your-number")}
      </Text>
      <div className="input">
        <Input
          name="phoneNumber"
          handleChange={handleChange}
          value={phoneNumber}
          label={Translation.t("label.mobile-number")}
          style={{ direction: "ltr" }}
          type="tel"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <span style={{ fontSize: "15px" }}>{Translation.n("+98")}</span>
              </InputAdornment>
            ),
          }}
        />
      </div>
      {securityWarn && (
        <div className="countdown">
          <CountDown
            nextRetry={optLimitTime}
            color="rgba(0, 0, 0, 1)"
            contentAfter={
              <span className="countdown-text">
                {Translation.t("text.wait-until")}
              </span>
            }
          />
        </div>
      )}
      <Button
        className="button"
        loading={loading}
        disabled={!phoneNumber}
        type="submit"
      >
        {Translation.t("label.sign-up-in")}
      </Button>
    </ContactInfoWrapper>
  );
};
export default SignUp;
